module.exports = __webpack_public_path__ + "img/1474472785.ca85abf1.jpg";